// extracted by mini-css-extract-plugin
export default {"CustomBadge":"StatusBadge_CustomBadge__+48XJ"};